import React from 'react';
import { Text, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCheck, faCircle, faGift } from '@fortawesome/pro-regular-svg-icons';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { useProfileCompletionBonus } from '../../../hooks/useProfileCompletionBonus';
import { profileBonusSections, showProfileBonusProgress } from '../../../helpers/profileCompletionBonus';
import CustomButton from '../../common/CustomButton';

export default function ProfileBonusCard({ onContinue, showSections = false }: { onContinue(): void; showSections?: boolean }) {
  const t = useTranslation();
  const theme = useCustomTheme();
  const { summary, refreshing } = useProfileCompletionBonus();
  if (!showProfileBonusProgress(summary)) return null;
  const ink = theme.isDark ? '#DCF4ED' : '#035164';
  const progressLabel = t('profile-bonus-progress', { completed: summary?.completedSections, total: summary?.totalSections });
  return <View testID="profile-bonus-progress" style={{ padding: 16, marginTop: 16, gap: 12, borderRadius: 12, backgroundColor: theme.background.missionDetail.toString() }}>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
      <FontAwesomeIcon icon={faGift} size={20} color={ink} />
      <Text accessibilityRole="header" style={{ color: ink, fontSize: 18, lineHeight: 24, fontWeight: '700', flex: 1 }}>{t('profile-bonus-title')}</Text>
    </View>
    <Text style={{ color: ink, fontSize: 14, lineHeight: 20 }}>{t('profile-bonus-offer', { points: summary?.rewardPoints })}</Text>
    <Text accessibilityLiveRegion="polite" style={{ color: ink, fontSize: 14, lineHeight: 20, fontWeight: '600' }}>{progressLabel}</Text>
    <View accessible accessibilityRole="progressbar" accessibilityValue={{ min: 0, max: 4, now: summary?.completedSections ?? 0 }}
      accessibilityLabel={t('profile-bonus-progress', { completed: summary?.completedSections, total: summary?.totalSections })}
      style={{ height: 6, borderRadius: 3, backgroundColor: theme.isDark ? '#42676C' : '#C8DFDC', overflow: 'hidden' }}>
      <View style={{ height: 6, width: `${Math.min(1, (summary?.completedSections ?? 0) / 4) * 100}%`, backgroundColor: '#43A7A1' }} />
    </View>
    {showSections && profileBonusSections.map(section => {
      const complete = !section.questions.some(key => summary?.missingQuestionKeys.includes(key));
      return <View key={section.key} style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
        <View style={{ width: 18 }}><FontAwesomeIcon icon={complete ? faCheck : faCircle} size={complete ? 16 : 12} color={ink} /></View>
        <Text style={{ color: ink, fontSize: 14, lineHeight: 20, flex: 1 }}>{t(section.key)}</Text>
      </View>;
    })}
    <CustomButton accessibilityRole="button" title={t(summary?.completedSections ? 'profile-bonus-continue' : 'profile-bonus-start')} disabled={refreshing}
      onPress={onContinue} style={{ minHeight: 44, alignSelf: 'stretch' }} textStyle={{ color: 'white' }}
      contentStyle={{ flex: 0, height: 'auto', minHeight: 44 }} />
  </View>;
}
